import React, { Component } from 'react';
import { map, truncate } from 'lodash';
import { dateToTime } from '../../helpers';
import { appBasePath } from '../../constants/staticData';

export default class AppliedList extends Component {
  constructor(props){
    super(props);
    this.windowWidth = this.windowWidth.bind(this);
  }
  windowWidth() {
    let docElemProp = window.document.documentElement.clientWidth,
      body = window.document.body;
    return window.document.compatMode === "CSS1Compat" && docElemProp || body && body.clientWidth || docElemProp;
  }
  render() {
    const {data, vat} = this.props;
    let discountAmount = 0;
    if (data && data.discountAmount) {
      discountAmount = data.discountAmount;
    }else if (data && data.garagejobquote && data.garagejobquote.discountAmount ) {
      discountAmount =  data.garagejobquote.discountAmount;
    }

    let totalAmount = 0;
    let subTotalAmount = 0;
    let vatAmount = 0;

    subTotalAmount = discountAmount? data.totalamount - discountAmount: data.totalamount;
    vatAmount =  subTotalAmount ? Number(subTotalAmount) *( Number(vat)/100): 0;
    totalAmount = subTotalAmount? Number(subTotalAmount)+Number(vatAmount) : 0;




    let months = ["Jan", "Feb", "Mar", "Apr", "May", "Jun", "Jul", "Aug", "Sep", "Oct", "Nov", "Dec"];
    let jobStartDate = data && new Date(data.jobStartDatetime);
    let serviceType = 'repair';
    const vehicles = (data.userbookingrequest && data.userbookingrequest.vehicles) ? data.userbookingrequest.vehicles : data.vehicles;
    const location = (data.userbookingrequest && data.userbookingrequest.location) ? data.userbookingrequest.location : data.location;
    let serviceName = '', quotesCount = 0;
    if (data.garagejobquotesdetail && data.garagejobquotesdetail.length) {
      serviceName = data.garagejobquotesdetail[0].garagejobquotesdetail_services.name;
      quotesCount = data.garagejobquotesdetail.length;
    } else {
      serviceName = (data.userbookingrequest_services && data.userbookingrequest_services.length ) ? data.userbookingrequest_services[0].name : '';
      quotesCount = (data.userbookingrequest_services && data.userbookingrequest_services.length) ? data.userbookingrequest_services.length : 0;
    }
    if ((data.userbookingrequest && data.userbookingrequest.serviceId == 1) || data.serviceId == 1) {
      serviceType = 'wash';
    }
    if ((data.userbookingrequest && data.userbookingrequest.serviceId == 3) || data.serviceId == 3) {
      serviceType = 'repair';
    }
    if ((data.userbookingrequest && data.userbookingrequest.serviceId == 2) || data.serviceId == 2) {
      serviceType = 'service';
    }
    const windowWidth = this.windowWidth();
    return (
      <div>
        <div onClick={() => { windowWidth < 992 ? this.props.router.push(`${appBasePath}/job/${data.userbookingrequestId}`) : this.props.onCardClick(data.userbookingrequestId); }}>
          <div className={"result-card status-card mhide " + serviceType}>
            <ul className="list-unstyled">
              <li className="age-data">
                <div className="result-card-title">
                  <span>{months[jobStartDate.getMonth()] + ' ' + jobStartDate.getDate() + ' , ' + jobStartDate.getFullYear()}</span>
                  <label>{dateToTime(jobStartDate)}</label>
                </div>
              </li>
              <li className="amt-data">
                {data.totalamount ? Number(totalAmount).toFixed(2) + ' AED' : 'FREE'}
              </li>
              <li className="job-data">
                <label> {data.userbookingrequest && data.userbookingrequest.requestid ? data.userbookingrequest && data.userbookingrequest.requestid : data.requestid} {(vehicles && vehicles.carmake && vehicles.carmodel)? (vehicles.carmake + ' ' + vehicles.carmodel) : ''}</label>
                <span>
                  {serviceName || ''}
                  {quotesCount > 1 && ' + ' + (quotesCount-1) + ' More'}
                </span>
              </li>
              <li className="area-data">
                {location ? truncate(location) : '-'}
              </li>
            </ul>
          </div>
          <div className={"result-card status-card mshow " + serviceType}>
            <ul className="list-unstyled">
              <li>
                <label>
                  Scheduled Date / TIME
                </label>
                <span>
                  <li className="age-data">
                    <div className="result-card-title">
                      <span>{months[jobStartDate.getMonth()] + ' ' + jobStartDate.getDate() + ' , ' + jobStartDate.getFullYear()}</span>
                      <label>{dateToTime(jobStartDate)}</label>
                    </div>
                  </li>
                </span>
              </li>
              <li className="amt-data">
                <label>Amount</label>
                <span>
                  {data.totalamount ? (Number(data.totalamount - discountAmount) ? `${Number(data.totalamount - discountAmount).toFixed(2)} AED` : 'FREE') : 'FREE'}
                </span>
              </li>
              <li className="job-data">
                <label>JOB ID / DETAILS</label>
                <span>
                  {data.userbookingrequest && data.userbookingrequest.requestid ? data.userbookingrequest && data.userbookingrequest.requestid : data.requestid}
                  <span className="display-block">
                    {serviceName || ''}
                    {quotesCount.length > 1 && ' + ' + quotesCount.length + ' More'}
                  </span>
                </span>
              </li>
              <li className="job-data">
                <label>AREA</label>
                <span> {location ? truncate(location) : '-'} </span>
              </li>
            </ul>
          </div>
        </div>
      </div>
    );
  }
}



// WEBPACK FOOTER //
// ./src/components/StatusList/AppliedList.jsx